<template>
  <b-dropdown
    size="sm"
    id="kt_quick_search_toggle"
    variant="link"
    toggle-class="topbar-item text-decoration-none px-0"
    v-b-tooltip.hover.bottom
    :title="(currentUser.project_invites.length > 0) ? $t('TOOLBAR.LANGUAGE.MY_PROJECTS_INVITED') : $t('TOOLBAR.LANGUAGE.MY_PROJECTS')"
    no-caret
    right
    no-flip
  >
    <template v-slot:button-content>
      <div
        class="btn btn-icon btn-clean btn-lg btn-dropdown mr-0"
      >
        <span
          class="svg-icon svg-icon-primary svg-icon-2x"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="24px"
            height="24px"
            viewBox="0 0 24 24"
            version="1.1"
          >
            <g
              stroke="none"
              stroke-width="1"
              fill="none"
              fill-rule="evenodd"
            >
              <rect x="0" y="0" width="24" height="24"/>
              <path d="M12,8 L8,8 C5.790861,8 4,9.790861 4,12 L4,13 C4,14.6568542 5.34314575,16 7,16 L7,18 C4.23857625,18 2,15.7614237 2,13 L2,12 C2,8.6862915 4.6862915,6 8,6 L12,6 L12,4.72799742 C12,4.62015048 12.0348702,4.51519416 12.0994077,4.42878885 C12.264656,4.2075478 12.5779675,4.16215674 12.7992086,4.32740507 L15.656242,6.46136716 C15.6951359,6.49041758 15.7295917,6.52497737 15.7585249,6.56395854 C15.9231063,6.78569617 15.876772,7.09886961 15.6550344,7.263451 L12.798001,9.3840407 C12.7118152,9.44801079 12.607332,9.48254921 12.5,9.48254921 C12.2238576,9.48254921 12,9.25869158 12,8.98254921 L12,8 Z" fill="#000000"/>
              <path d="M12.0583175,16 L16,16 C18.209139,16 20,14.209139 20,12 L20,11 C20,9.34314575 18.6568542,8 17,8 L17,6 C19.7614237,6 22,8.23857625 22,11 L22,12 C22,15.3137085 19.3137085,18 16,18 L12.0583175,18 L12.0583175,18.9825492 C12.0583175,19.2586916 11.8344599,19.4825492 11.5583175,19.4825492 C11.4509855,19.4825492 11.3465023,19.4480108 11.2603165,19.3840407 L8.40328311,17.263451 C8.18154548,17.0988696 8.13521119,16.7856962 8.29979258,16.5639585 C8.32872576,16.5249774 8.36318164,16.4904176 8.40207551,16.4613672 L11.2591089,14.3274051 C11.48035,14.1621567 11.7936615,14.2075478 11.9589099,14.4287888 C12.0234473,14.5151942 12.0583175,14.6201505 12.0583175,14.7279974 L12.0583175,16 Z" fill="#000000" opacity="0.3"/>
              <circle
                v-if="currentUser.project_invites.length > 0"
                opacity="1"
                cx="18.5"
                cy="7.5"
                r="5"
                style="fill: white !important"
              />
              <circle
                v-if="currentUser.project_invites.length > 0"
                class="project_navigate_hint"
                opacity="1"
                cx="18.5"
                cy="5.5"
                r="2.5"
              />
            </g>
          </svg>
        </span>
      </div>
    </template>
    <b-dropdown-text tag="div" class="min-w-md-350px">
      <div v-if="possibleProjects.length > 0">
        <div class="form-group mb-2">
          <div class="input-icon input-icon-right">
            <input v-model="filter.search" type="text" class="project-search form-control" placeholder="Project Name/Key..."/>
            <span>
              <a href="javascript:void(0)" class="pt-1" @click="showOptions = !showOptions">
                <i
                  class="fas fa-cog"
                  :class="(showOptions) ? 'text-primary' : 'text-muted'"
                />
              </a>
            </span>
          </div>
        </div>

        <ProjectList
          v-if="!showOptions"
          :calculatedProjects="calculatedProjects"
        />

        <FilterOptions
          v-else
          :filter="filter"
          @on-setting-change="filter[$event.option] = $event.value"
        />

      </div>

      <div v-else>

        <div class="d-flex align-items-center justify-content-center pt-5 pb-5">
          <span class="svg-icon svg-icon-5x">
            <inline-svg src="media/svg/icons/Communication/Clipboard-list.svg" />
          </span>          
        </div>

        <div class="d-flex align-items-center justify-content-center pt-2 pb-5">
          <span class="row text-muted text-center w-75">{{ $t('TOOLBAR.LANGUAGE.MY_PROJECTS_PLACEHOLDER') }}</span>
        </div>
        
      </div>
    </b-dropdown-text>
  </b-dropdown>
</template>

<script>
import {
  mapGetters
} from "vuex";

import ProjectList from "./project-selection/ProjectList.vue";
import FilterOptions from "./project-selection/FilterOptions.vue";

export default {
  name: "ProjectSelection",

  data() {
    return {
      showOptions: false,
      filter: {
        search: "",
        community_manager: true,
        observer: true,
        participant: true,
        subscribed: true,
        invited: true
      }
    }
  },

  components: {
    ProjectList,
    FilterOptions
  },

  computed: {
    ...mapGetters([
      "currentUser"
    ]),
    possibleProjects: function() {
      return this.currentUser.project_invites.concat(this.currentUser.projects);
    },
    calculatedProjects: function() {
      let invitedProjects     = [];
      let subscribedProjects  = [];

      if (this.filter.invited) {
        invitedProjects     = this.currentUser.project_invites;
      }

      if (this.filter.subscribed) {
        subscribedProjects  = this.currentUser.projects;
      };

      const self = this;
      let combinedProjects  = invitedProjects.concat(subscribedProjects);
      combinedProjects      = combinedProjects.filter(function(project) {
        return (
          (
            (project.name.toLowerCase().includes(self.filter.search.toLowerCase()) || self.filter.search.length == 0) ||
            (project.key.toLowerCase().includes(self.filter.search.toLowerCase()) || self.filter.search.length == 0)
          ) && (
            self.filter.community_manager && project.pivot.system_project_role_id == 3 ||
            self.filter.observer && project.pivot.system_project_role_id == 2 ||
            self.filter.participant && project.pivot.system_project_role_id == 1
          )
        )
      })

      return combinedProjects;

    },    
  }
}
</script>

<style scoped>
  .project-search {
    background: transparent !important;
    border-top: 0px !important;
    border-left: 0px !important;
    border-right: 0px !important;
    border-bottom: 1px solid #f0f1f2 !important;
    border-radius: 0px;
  }
</style>